function LabelGeral({ nome, estilo }) {
    return (
      <label style={{...estilo, fontFamily: "Roboto",}} htmlFor={nome}>{nome}</label>
    );
  }
  
  export default LabelGeral;
  